import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { Municipio } from './Municipio';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { Provincia } from '../Provincias/Provincia';
import ErrorDialog from '../utilities/ErrorDialog';

export interface IMunicipioEditProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
    selectedItem: Municipio | undefined;
}

export interface IMunicipioEditState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    provincias: Provincia[];
    openErroDialog: boolean;
}

export default class MunicipioEdit extends React.Component<IMunicipioEditProps, IMunicipioEditState> {
    _municipio: Municipio = new Municipio();
    _id: number = -1;
    
    public constructor(props: IMunicipioEditProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            provincias: [],
            openErroDialog: false
        }
    }

    componentDidMount(): void {
        this.GetComunidadesAutonomas();
    }

    componentWillReceiveProps(nextProps: Readonly<IMunicipioEditProps>, nextContext: any): void {
        if(nextProps.selectedItem != null) {
            this._municipio = nextProps.selectedItem;
        }

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Modificar municipio
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Código' defaultValue={this._municipio.codigo} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._municipio.codigo = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Nombre' defaultValue={this._municipio.nombre} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._municipio.nombre = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                            <FormControl fullWidth variant="standard">
                                <InputLabel id="labelComunidadAutonoma">Seleccione una provincia</InputLabel>
                                <Select label="Seleccione una provincia" defaultValue={this._municipio.provincia} labelId='labelComunidadAutonoma' onChange={(event: SelectChangeEvent) => {
                                    this._municipio.provincia = event.target.value;
                                }}>
                                    {
                                        this.state.provincias.map((value: Provincia, index: number) => {
                                            return (
                                                <MenuItem value={value.nombre}>
                                                    {
                                                        value.nombre
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Update.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                hasErrors: false,
                errorMessage: '',
                openErroDialog: false
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private GetComunidadesAutonomas(): void {
        let url = `${Common.END_POINT}/masters/provincias`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    provincias: response,
                    hasErrors: false
                }
            );
        })
    }

    private Update() {
        if(this._municipio.nombre == '' || this._municipio.nombre == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/municipios/${this._municipio.id}/update`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._municipio),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._municipio = new Municipio();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._municipio = new Municipio();
        });
    }
}